import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContext from '../../../../../contexts/ModalContext';

import Dialog from '@pelckmans/elementis/components/dialog';
import Button from '@pelckmans/elementis/components/button';

type Props = {
  id: string;
  onConfirm: () => Promise<void>;
};

export function DeleteMaterialConfirmationModal({ id, onConfirm }: Props) {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  const handleClose = () => {
    closeModal(id);
  };

  const handleDelete = async () => {
    await onConfirm();
  };

  return (
    <Dialog
      id={id}
      modal
      size="sm"
      onClose={handleClose}
      aria-label={t('PAGES.MY_GROUPS.MODALS.DELETE_MATERIAL_CONFIRMATION.A11Y_LABEL')}
    >
      <Dialog.Header
        title={t('PAGES.MY_GROUPS.MODALS.DELETE_MATERIAL_CONFIRMATION.HEADER.TITLE')}
        onClose={handleClose}
        aria-label={t('PAGES.MY_GROUPS.MODALS.DELETE_MATERIAL_CONFIRMATION.HEADER.ACTIONS.CLOSE')}
        danger
      />
      <Dialog.Body>{t('PAGES.MY_GROUPS.MODALS.DELETE_MATERIAL_CONFIRMATION.BODY')}</Dialog.Body>
      <Dialog.Footer
        buttonGroupPropsRight={{
          'aria-label': undefined,
          role: undefined,
          children: (
            <>
              <Button prominence="neutral" onClick={handleClose} key="cancel">
                {t('PAGES.MY_GROUPS.MODALS.DELETE_MATERIAL_CONFIRMATION.FOOTER.ACTIONS.CANCEL')}
              </Button>
              <Button prominence="danger" onClick={handleDelete} key="confirm">
                {t('PAGES.MY_GROUPS.MODALS.DELETE_MATERIAL_CONFIRMATION.FOOTER.ACTIONS.CONFIRM')}
              </Button>
            </>
          ),
        }}
      />
    </Dialog>
  );
}
